import React from "react";

import PropTypes from "prop-types";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";

import InputDate from "components/RH/inputs/InputDate";
import MaskUtil from "utils/MaskUtil";

const InformacoesDependentes = ({
  dados,
  HandleChange,
  dependente,
  setDependente,
  HandleAddDependente,
  RemoverDependente,
  tiposParentesco,
  errors = {},
  HandleDependenteChange
}) => {
  // Usa apenas os tipos de parentesco carregados da API
  const parentescos = tiposParentesco || [];  

  return (
    <div className="row g-3">
      <div className="col-md-6 col-lg-3">
        <div className="d-flex flex-column">
          <label htmlFor="possuiDependentes" className="form-label">
            Possui Dependentes?
          </label>
          <InputSwitch
            id="possuiDependentes"
            checked={dados.possuiDependentes}
            onChange={(e) =>
              HandleChange({
                target: { name: "possuiDependentes", value: e.value }
              })
            }
          />
        </div>
      </div>
      {dados?.possuiDependentes && (
        <div className="col-12">
          <div className="row g-3">
            <div className="col-12">
              <h4>Cadastro de Dependentes</h4>
            </div>
            <div className="col-md-6 col-lg-3">
              <label>Nome do Dependente <span className="text-danger">*</span></label>
              <InputText
                value={dependente.nome}
                onChange={(e) =>
                  HandleDependenteChange('nome', e.target.value)
                }
                className={`w-100 ${errors.nome ? 'is-invalid border-danger' : ''}`}
                style={errors.nome ? { borderColor: '#dc3545' } : {}}
              />
              {errors.nome && (
                <div className="invalid-feedback">
                  Nome do dependente é obrigatório
                </div>
              )}
            </div>
            <div className="col-md-6 col-lg-3">
              <label>Data de Nascimento <span className="text-danger">*</span></label>
              <InputDate
                value={dependente.dataNascimento}
                onChange={(dateString) =>
                  HandleDependenteChange('dataNascimento', dateString)
                }
                placeholder="dd/mm/aaaa"
                className={`w-100 ${errors.dataNascimento ? 'border-danger' : ''}`}
                style={errors.dataNascimento ? { borderColor: '#dc3545' } : {}}
              />
              {errors.dataNascimento && (
                <div className="invalid-feedback">
                  Data de nascimento é obrigatória
                </div>
              )}
            </div>
            <div className="col-md-6 col-lg-3">
              <label>Parentesco <span className="text-danger">*</span></label>
              <Dropdown
                value={dependente.parentesco}
                options={parentescos}
                onChange={(e) =>
                  HandleDependenteChange('parentesco', e.value)
                }
                className={`w-100 ${errors.parentesco ? 'border-danger' : ''}`}
                style={errors.parentesco ? { borderColor: '#dc3545' } : {}}
              />
              {errors.parentesco && (
                <div className="invalid-feedback">
                  Parentesco é obrigatório
                </div>
              )}
            </div>
            <div className="col-md-6 col-lg-3">
              <label>CPF <span className="text-danger">*</span></label>
              <InputText
                value={dependente.cpf}
                onChange={(e) =>
                  HandleDependenteChange('cpf', MaskUtil.applyCpfMask(e.target.value))
                }
                className={`w-100 ${errors.cpf ? 'is-invalid border-danger' : ''}`}
                style={errors.cpf ? { borderColor: '#dc3545' } : {}}
              />
              {errors.cpf && (
                <div className="invalid-feedback">
                  CPF é obrigatório
                </div>
              )}
            </div>
            <div className="col-12">
              <div className="d-flex flex-row-reverse">
                <Button
                  type="button"
                  label="Adicionar Dependente"
                  icon="pi pi-plus"
                  onClick={HandleAddDependente}
                />
              </div>
            </div>
            <div className="col-12">
              <DataTable value={dados.dependentes}>
                <Column field="nome" header="Nome" />
                <Column 
                  field="parentesco" 
                  header="Parentesco"
                  body={(row) => {
                    // Usa a descrição que vem do backend, com fallback para busca local
                    if (row.parentescoDescricao) {
                      return row.parentescoDescricao;
                    }
                    const tipoParentesco = parentescos.find(tipo => tipo.value === row.parentesco);
                    return tipoParentesco ? tipoParentesco.label : row.parentesco;
                  }}
                />
                <Column field="cpf" header="CPF" />
                <Column
                  field="dataNascimento"
                  header="Data de Nascimento"
                  body={(row) => MaskUtil.applyDataMask(row.dataNascimento)}
                />
                <Column
                  header="Ação"
                  body={(row) => (
                    <Button
                      type="button"
                      label="Remover"
                      onClick={() => RemoverDependente(row.cpf)}
                    />
                  )}
                />
              </DataTable>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

InformacoesDependentes.propTypes = {
  dados: PropTypes.shape({
    possuiDependentes: PropTypes.bool.isRequired,
    dependentes: PropTypes.arrayOf(
      PropTypes.shape({
        nome: PropTypes.string.isRequired,
        parentesco: PropTypes.string.isRequired,
        cpf: PropTypes.string.isRequired,
        dataNascimento: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.instanceOf(Date)
        ]).isRequired
      })
    ).isRequired
  }).isRequired,
  HandleChange: PropTypes.func.isRequired,
  dependente: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    parentesco: PropTypes.string.isRequired,
    cpf: PropTypes.string.isRequired,
    dataNascimento: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]).isRequired
  }).isRequired,
  setDependente: PropTypes.func.isRequired,
  HandleAddDependente: PropTypes.func.isRequired,
  RemoverDependente: PropTypes.func.isRequired,
  tiposParentesco: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ),
  errors: PropTypes.shape({
    nome: PropTypes.bool,
    dataNascimento: PropTypes.bool,
    parentesco: PropTypes.bool,
    cpf: PropTypes.bool
  }),
  HandleDependenteChange: PropTypes.func
};

InformacoesDependentes.defaultProps = {
  tiposParentesco: [],
  errors: {},
  HandleDependenteChange: undefined
};

export default InformacoesDependentes;
